// extracted by mini-css-extract-plugin
export default {"btn":"BlueBorderButton_btn__7bRz4"};